/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";

import diagnosticoService from "../../api/atendimentos/diagnosticoService";
import {
    formataDataExibicao,
    formataDataHoraExibicao,
    tiposDiagnosticoLinhaCuidado,
    tiposDocumentoDiagnostico,
    tooltipsDiagnosticoLinhaCuidado,
} from "../../common/utils";

class DiagnosticoDoencasAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            enviandoDocumento: false,
            erro: "",
            principal: null,
            concomitantes: [],
            comorbidades: [],
            showModal: false,
            formulario: this.getFormularioInicial(),
            showModalPatologia: false,
            formPatologia: { nome: "", cid_id: "", cid_label: "" },
            salvandoPatologia: false,
            showModalDocumento: false,
            formDocumento: { diagnostico_id: null, tipo: "prescricao", descricao: "", arquivo: null },
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    getFormularioInicial = () => ({
        id: null,
        doenca_id: "",
        doenca_label: "",
        tipo_doenca: "doenca_alvo",
        data_diagnostico: "",
        estadiamento: "",
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, principal: null, concomitantes: [], comorbidades: [] });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await diagnosticoService.listar(atendimentoId);
            const data = response.data || {};

            this.setState({
                loading: false,
                principal: data.diagnostico_principal || null,
                concomitantes: Array.isArray(data.concomitantes) ? data.concomitantes : [],
                comorbidades: Array.isArray(data.comorbidades) ? data.comorbidades : [],
            });
        } catch (error) {
            console.error("Erro ao carregar diagnóstico e doenças:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar o diagnóstico do paciente."),
            });
        }
    };

    carregarPatologias = async (inputValue) => {
        const patologias = await diagnosticoService.buscarPatologias(inputValue);

        return patologias.map((patologia) => ({
            value: patologia.id,
            label: patologia.dados_cid?.codigo
                ? `${patologia.nome} (${patologia.dados_cid.codigo})`
                : patologia.nome,
        }));
    };

    carregarCids = async (inputValue) => {
        const lista = await diagnosticoService.buscarCids(inputValue);

        return lista.map((cid) => ({
            value: cid.id,
            label: `${cid.codigo} - ${cid.descricao || ""}`.trim(),
        }));
    };

    abrirModalNovo = (tipoDoenca) => {
        this.setState({
            showModal: true,
            formulario: { ...this.getFormularioInicial(), tipo_doenca: tipoDoenca },
        });
    };

    abrirModalEdicao = (registro) => {
        this.setState({
            showModal: true,
            formulario: {
                id: registro.id,
                doenca_id: registro.doenca_id,
                doenca_label: registro.dados_doenca?.cid_codigo
                    ? `${registro.dados_doenca.nome} (${registro.dados_doenca.cid_codigo})`
                    : registro.dados_doenca?.nome || "",
                tipo_doenca: registro.tipo_doenca,
                data_diagnostico: registro.data_diagnostico || "",
                estadiamento: registro.estadiamento || "",
            },
        });
    };

    fecharModal = () => this.setState({ showModal: false, formulario: this.getFormularioInicial() });

    onChangeFormulario = (event) => {
        const { name, value } = event.target;
        this.setState((estado) => ({ formulario: { ...estado.formulario, [name]: value } }));
    };

    salvar = async () => {
        const { atendimentoId } = this.props;
        const { formulario } = this.state;

        if (!formulario.doenca_id) {
            Swal.fire("Atenção", "Selecione a patologia.", "warning");
            return;
        }

        const payload = {
            atendimento_id: atendimentoId,
            doenca_id: formulario.doenca_id,
            tipo_doenca: formulario.tipo_doenca,
            data_diagnostico: formulario.data_diagnostico || null,
            estadiamento: formulario.estadiamento || "",
        };

        this.setState({ salvando: true });

        try {
            if (formulario.id) {
                await diagnosticoService.update(formulario.id, payload);
            } else {
                await diagnosticoService.create(payload);
            }

            this.setState({ salvando: false, showModal: false, formulario: this.getFormularioInicial() });
            await this.carregar();
            Swal.fire("Sucesso", formulario.id ? "Diagnóstico atualizado com sucesso." : "Diagnóstico adicionado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar diagnóstico:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar o diagnóstico."), "error");
        }
    };

    excluir = async (registro) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar exclusão?",
            text: `Deseja remover ${registro.dados_doenca?.nome || "esta patologia"} do paciente? Os documentos anexados também serão removidos.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await diagnosticoService.delete(registro.id);
            await this.carregar();
            Swal.fire("Sucesso", "Patologia removida com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao remover diagnóstico:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover a patologia."), "error");
        }
    };

    abrirModalPatologia = () => this.setState({ showModalPatologia: true, formPatologia: { nome: "", cid_id: "", cid_label: "" } });

    fecharModalPatologia = () => this.setState({ showModalPatologia: false });

    salvarPatologia = async () => {
        const { formPatologia } = this.state;

        if (!formPatologia.nome.trim()) {
            Swal.fire("Atenção", "Informe o nome da patologia.", "warning");
            return;
        }

        if (!formPatologia.cid_id) {
            Swal.fire("Atenção", "Informe o CID da patologia.", "warning");
            return;
        }

        this.setState({ salvandoPatologia: true });

        try {
            const resposta = await diagnosticoService.cadastrarPatologia(formPatologia.nome.trim(), formPatologia.cid_id);
            const nova = resposta.data || {};

            this.setState((estado) => ({
                salvandoPatologia: false,
                showModalPatologia: false,
                formulario: {
                    ...estado.formulario,
                    doenca_id: nova.id,
                    doenca_label: formPatologia.cid_label ? `${nova.nome} (${formPatologia.cid_label.split(" - ")[0]})` : nova.nome,
                },
            }));

            Swal.fire("Sucesso", "Patologia cadastrada e selecionada.", "success");
        } catch (error) {
            console.error("Erro ao cadastrar patologia:", error);
            this.setState({ salvandoPatologia: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível cadastrar a patologia."), "error");
        }
    };

    abrirModalDocumento = (diagnosticoId) => {
        this.setState({
            showModalDocumento: true,
            formDocumento: { diagnostico_id: diagnosticoId, tipo: "prescricao", descricao: "", arquivo: null },
        });
    };

    fecharModalDocumento = () => this.setState({ showModalDocumento: false });

    onChangeDocumento = (event) => {
        const { name, value, files } = event.target;
        this.setState((estado) => ({
            formDocumento: { ...estado.formDocumento, [name]: files ? files[0] : value },
        }));
    };

    enviarDocumento = async () => {
        const { formDocumento } = this.state;

        if (!formDocumento.arquivo) {
            Swal.fire("Atenção", "Selecione o arquivo.", "warning");
            return;
        }

        if (formDocumento.tipo === "outro" && !formDocumento.descricao.trim()) {
            Swal.fire("Atenção", 'A descrição é obrigatória quando o tipo do documento é "Outro".', "warning");
            return;
        }

        this.setState({ enviandoDocumento: true });

        try {
            await diagnosticoService.enviarDocumento(
                formDocumento.diagnostico_id,
                formDocumento.tipo,
                formDocumento.descricao.trim(),
                formDocumento.arquivo
            );

            this.setState({ enviandoDocumento: false, showModalDocumento: false });
            await this.carregar();
            Swal.fire("Sucesso", "Documento anexado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao anexar documento:", error);
            this.setState({ enviandoDocumento: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível anexar o documento."), "error");
        }
    };

    excluirDocumento = async (documento) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar exclusão?",
            text: "Deseja remover este documento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await diagnosticoService.excluirDocumento(documento.id);
            await this.carregar();
            Swal.fire("Sucesso", "Documento removido com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao remover documento:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover o documento."), "error");
        }
    };

    renderTooltip = (chave) => {
        const texto = tooltipsDiagnosticoLinhaCuidado[chave];

        if (!texto) {
            return null;
        }

        return (
            <OverlayTrigger placement="right" overlay={<Tooltip>{texto}</Tooltip>}>
                <i className="bi bi-info-circle ms-2 text-muted" role="img" aria-label={texto} />
            </OverlayTrigger>
        );
    };

    renderDocumentos = (registro) => {
        const { podeEditar } = this.props;
        const documentos = registro.documentos || [];

        if (documentos.length === 0) {
            return <span className="text-muted">Nenhum documento anexado.</span>;
        }

        return (
            <ul className="list-unstyled mb-0">
                {documentos.map((documento) => (
                    <li key={documento.id} className="mb-1">
                        <Badge bg="secondary" className="me-2">
                            {tiposDocumentoDiagnostico[documento.tipo] || documento.tipo_display}
                        </Badge>
                        {documento.arquivo_url ? (
                            <a href={documento.arquivo_url} target="_blank" rel="noreferrer">
                                {documento.nome_original || "Abrir documento"}
                            </a>
                        ) : (
                            <span>{documento.nome_original || "-"}</span>
                        )}
                        {documento.descricao && <span className="text-muted"> — {documento.descricao}</span>}
                        {documento.data_criacao && (
                            <small className="text-muted"> ({formataDataHoraExibicao(documento.data_criacao)})</small>
                        )}
                        {podeEditar && (
                            <Button
                                variant="link"
                                size="sm"
                                className="text-danger p-1"
                                onClick={() => this.excluirDocumento(documento)}
                            >
                                Excluir
                            </Button>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    renderTabela = (registros, tipo) => {
        const { podeEditar } = this.props;

        return (
            <Table responsive className="custom-table table-sm align-middle mb-0">
                <thead>
                    <tr>
                        <th>Patologia</th>
                        <th>CID</th>
                        <th>Data do diagnóstico</th>
                        <th>Estadiamento</th>
                        <th>Documentos</th>
                        {podeEditar && <th className="text-end">Ações</th>}
                    </tr>
                </thead>
                <tbody>
                    {registros.length === 0 ? (
                        <tr>
                            <td colSpan={podeEditar ? 6 : 5} className="text-center">
                                Nenhum registro para {tiposDiagnosticoLinhaCuidado[tipo]?.toLowerCase() || "esta classificação"}.
                            </td>
                        </tr>
                    ) : (
                        registros.map((registro) => (
                            <tr key={registro.id}>
                                <td>{registro.dados_doenca?.nome || "-"}</td>
                                <td>{registro.dados_doenca?.cid_codigo || "-"}</td>
                                <td>{registro.data_diagnostico ? formataDataExibicao(registro.data_diagnostico) : "-"}</td>
                                <td>{registro.estadiamento || "-"}</td>
                                <td>{this.renderDocumentos(registro)}</td>
                                {podeEditar && (
                                    <td className="text-end">
                                        <Button variant="outline-secondary" size="sm" className="me-2" onClick={() => this.abrirModalEdicao(registro)}>
                                            Editar
                                        </Button>
                                        <Button variant="outline-primary" size="sm" className="me-2" onClick={() => this.abrirModalDocumento(registro.id)}>
                                            Anexar
                                        </Button>
                                        <Button variant="outline-danger" size="sm" onClick={() => this.excluir(registro)}>
                                            Remover
                                        </Button>
                                    </td>
                                )}
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    renderSecao = (titulo, tipo, registros, permitirAdicionar = true) => {
        const { podeEditar } = this.props;

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <Row className="align-items-center mb-3">
                        <Col sm={8}>
                            <h5 className="mb-0">
                                {titulo}
                                {this.renderTooltip(tipo)}
                            </h5>
                        </Col>
                        <Col sm={4} className="text-end">
                            {podeEditar && permitirAdicionar && (
                                <Button variant="outline-primary" size="sm" onClick={() => this.abrirModalNovo(tipo)}>
                                    Adicionar
                                </Button>
                            )}
                        </Col>
                    </Row>
                    {this.renderTabela(registros, tipo)}
                </Card.Body>
            </Card>
        );
    };

    renderModalDiagnostico = () => {
        const { showModal, formulario, salvando } = this.state;

        return (
            <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{formulario.id ? "Editar diagnóstico" : "Adicionar patologia"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <Form.Label className="mb-0">Patologia *</Form.Label>
                                <Button variant="link" size="sm" onClick={this.abrirModalPatologia}>
                                    Cadastrar nova patologia
                                </Button>
                            </div>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={this.carregarPatologias}
                                value={formulario.doenca_id ? { value: formulario.doenca_id, label: formulario.doenca_label } : null}
                                onChange={(opcao) =>
                                    this.setState((estado) => ({
                                        formulario: { ...estado.formulario, doenca_id: opcao?.value || "", doenca_label: opcao?.label || "" },
                                    }))
                                }
                                placeholder="Busque pelo nome da patologia..."
                                noOptionsMessage={() => "Nenhuma patologia encontrada"}
                            />
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Classificação *</Form.Label>
                            <Form.Select name="tipo_doenca" value={formulario.tipo_doenca} onChange={this.onChangeFormulario}>
                                {Object.entries(tiposDiagnosticoLinhaCuidado).map(([valor, label]) => (
                                    <option key={valor} value={valor}>
                                        {label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Data do diagnóstico</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_diagnostico"
                                max={new Date().toISOString().slice(0, 10)}
                                value={formulario.data_diagnostico}
                                onChange={this.onChangeFormulario}
                            />
                        </Col>
                        <Col sm={12} className="mb-3">
                            <Form.Label>Estadiamento da doença</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="estadiamento"
                                value={formulario.estadiamento}
                                onChange={this.onChangeFormulario}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                        {salvando ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalPatologia = () => {
        const { showModalPatologia, formPatologia, salvandoPatologia } = this.state;

        return (
            <Modal show={showModalPatologia} onHide={this.fecharModalPatologia} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Cadastrar patologia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Nome da patologia *</Form.Label>
                    <Form.Control
                        className="mb-3"
                        value={formPatologia.nome}
                        onChange={(event) =>
                            this.setState((estado) => ({ formPatologia: { ...estado.formPatologia, nome: event.target.value } }))
                        }
                    />
                    <Form.Label>CID *</Form.Label>
                    <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={this.carregarCids}
                        value={formPatologia.cid_id ? { value: formPatologia.cid_id, label: formPatologia.cid_label } : null}
                        onChange={(opcao) =>
                            this.setState((estado) => ({
                                formPatologia: { ...estado.formPatologia, cid_id: opcao?.value || "", cid_label: opcao?.label || "" },
                            }))
                        }
                        placeholder="Busque pelo código ou descrição do CID..."
                        noOptionsMessage={() => "Nenhum CID encontrado"}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalPatologia} disabled={salvandoPatologia}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvarPatologia} disabled={salvandoPatologia}>
                        {salvandoPatologia ? "Salvando..." : "Cadastrar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalDocumento = () => {
        const { showModalDocumento, formDocumento, enviandoDocumento } = this.state;

        return (
            <Modal show={showModalDocumento} onHide={this.fecharModalDocumento} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Anexar documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Classificação do documento *</Form.Label>
                    <Form.Select className="mb-3" name="tipo" value={formDocumento.tipo} onChange={this.onChangeDocumento}>
                        {Object.entries(tiposDocumentoDiagnostico).map(([valor, label]) => (
                            <option key={valor} value={valor}>
                                {label}
                            </option>
                        ))}
                    </Form.Select>
                    {formDocumento.tipo === "outro" && (
                        <>
                            <Form.Label>Descrição *</Form.Label>
                            <Form.Control
                                className="mb-3"
                                name="descricao"
                                value={formDocumento.descricao}
                                onChange={this.onChangeDocumento}
                            />
                        </>
                    )}
                    <Form.Label>Arquivo *</Form.Label>
                    <Form.Control type="file" name="arquivo" onChange={this.onChangeDocumento} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalDocumento} disabled={enviandoDocumento}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.enviarDocumento} disabled={enviandoDocumento}>
                        {enviandoDocumento ? "Enviando..." : "Anexar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { loading, erro, principal, concomitantes, comorbidades } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        return (
            <>
                {this.renderSecao("Diagnóstico Principal", "doenca_alvo", principal ? [principal] : [], !principal)}
                {this.renderSecao("Doenças concomitantes", "concomitante", concomitantes)}
                {this.renderSecao("Comorbidades relevantes", "comorbidade", comorbidades)}
                {this.renderModalDiagnostico()}
                {this.renderModalPatologia()}
                {this.renderModalDocumento()}
            </>
        );
    }
}

export default DiagnosticoDoencasAtendimento;
